import React, { Component, SyntheticEvent } from 'react'

import { gtmDataPush } from '../../utils/gtmDataPush'
import './GtmClick.css'

type Props = {
  category: string
  id: string

  children: JSX.Element | JSX.Element[]
  onClick?: (e: SyntheticEvent<HTMLElement>) => void
}

class GtmClick extends Component<Props> {
  eventUrl = ''
  componentDidMount() {
    this.eventUrl = window.location.href
  }

  fireEvent = (e: SyntheticEvent<HTMLElement>) => {
    gtmDataPush(this.props.category, this.props.id, this.eventUrl)

    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  render() {
    return (
      <div className="gtm-event-wrapper" onClick={this.fireEvent}>
        {this.props.children}
      </div>
    )
  }
}

export default GtmClick
